import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import axios from 'axios';

export default function ChartOfAccounts() {
  const { API } = useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      const response = await axios.get(`${API}/chart-of-accounts`);
      setAccounts(response.data);
    } catch (error) {
      console.error('Error loading accounts:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredAccounts = accounts.filter(
    (acc) =>
      acc.code.toLowerCase().includes(search.toLowerCase()) ||
      acc.name.toLowerCase().includes(search.toLowerCase())
  );

  const groupByType = (accounts) => {
    const groups = {};
    accounts.forEach((acc) => {
      if (!groups[acc.type]) {
        groups[acc.type] = [];
      }
      groups[acc.type].push(acc);
    });
    return groups;
  };

  const grouped = groupByType(filteredAccounts);

  if (loading) {
    return <div className="p-8">Cargando...</div>;
  }

  return (
    <div className="p-8 space-y-6" data-testid="chart-of-accounts-page">
      <div>
        <h1 className="text-3xl font-bold">Plan de Cuentas</h1>
        <p className="text-muted-foreground">Catálogo de cuentas contables</p>
      </div>

      <div className="flex gap-4">
        <Input
          data-testid="search-accounts-input"
          placeholder="Buscar por código o nombre..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="max-w-sm"
        />
      </div>

      <div className="space-y-6">
        {Object.entries(grouped).map(([type, accs]) => (
          <Card key={type}>
            <CardHeader>
              <CardTitle>{type}</CardTitle>
              <CardDescription>{accs.length} cuentas</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {accs.map((account) => (
                  <div
                    key={account.id}
                    data-testid={`account-${account.code}`}
                    className="flex justify-between items-center p-3 border rounded-lg hover:bg-secondary/50 transition-colors"
                  >
                    <div className="flex-1">
                      <div className="flex items-center gap-3">
                        <span className="font-mono font-bold text-primary">{account.code}</span>
                        <span className="font-medium">{account.name}</span>
                      </div>
                      {account.parent_code && (
                        <span className="text-xs text-muted-foreground">Padre: {account.parent_code}</span>
                      )}
                    </div>
                    <div className="text-right">
                      <div className="font-mono text-sm">
                        ${account.balance.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {filteredAccounts.length === 0 && (
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <p className="text-muted-foreground">No se encontraron cuentas</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}